/* assets/dvy-wishlist.js — Duvylin wishlist store + legacy section adapter */
(function () {
  'use strict';

  var KEY = 'dvy:wishlist:v1';
  var EVT = 'dvy:wishlist:change';
  var MAX = 120;
  var memory = null;

  /* legacy buttons jo abhi Product Showcase / Statement Showcase me hain */
  var LEGACY = '[data-ps-wish],[data-sw-wish]';
  var TOGGLE = '[data-dvy-wishlist-toggle]';
  var ANY = TOGGLE + ',' + LEGACY;
  var CARD = '[data-sw-card],[data-ps-card],.sw-card,.ps__item,.ps__card,li,article';

  /* ================= store ================= */

  function safeParse(raw) {
    try { var a = JSON.parse(raw); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }

  function normalize(arr) {
    var seen = Object.create(null), out = [];
    for (var i = 0; i < arr.length; i++) {
      var it = arr[i];
      if (!it || typeof it.handle !== 'string' || !it.handle) continue;
      if (seen[it.handle]) continue;
      seen[it.handle] = 1;
      out.push({
        handle: it.handle,
        id: it.id ? String(it.id) : '',
        title: typeof it.title === 'string' ? it.title : '',
        at: typeof it.at === 'number' ? it.at : Date.now()
      });
    }
    return out.slice(0, MAX);
  }

  function read() {
    if (memory) return memory.slice();
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? normalize(safeParse(raw)) : [];
    } catch (e) { memory = []; return []; }
  }

  function write(arr) {
    var next = normalize(arr);
    if (memory) memory = next;
    else {
      try { localStorage.setItem(KEY, JSON.stringify(next)); }
      catch (e) { memory = next; }
    }
    emit(next);
    return next;
  }

  function emit(items) {
    try {
      document.dispatchEvent(new CustomEvent(EVT, {
        detail: { items: items, count: items.length }
      }));
    } catch (e) {}
  }

  var API = {
    list: read,
    count: function () { return read().length; },
    has: function (h) {
      var items = read();
      for (var i = 0; i < items.length; i++) if (items[i].handle === h) return true;
      return false;
    },
    add: function (item) {
      if (!item || !item.handle) return read();
      var items = read();
      items.unshift({ handle: item.handle, id: item.id, title: item.title, at: Date.now() });
      return write(items);
    },
    remove: function (h) {
      return write(read().filter(function (i) { return i.handle !== h; }));
    },
    toggle: function (item) {
      if (API.has(item.handle)) { API.remove(item.handle); return false; }
      API.add(item); return true;
    },
    clear: function () { return write([]); },
    subscribe: function (fn) {
      document.addEventListener(EVT, function (e) { fn(e.detail); });
      var items = read();
      return fn({ items: items, count: items.length });
    },
    EVENT: EVT
  };

  /* ============ legacy adapter ============ */

  function handleFromHref(href) {
    if (!href) return '';
    var m = String(href).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function closestCard(btn) {
    return btn.closest ? btn.closest(CARD) : null;
  }

  function resolveHandle(btn) {
    var h = btn.getAttribute('data-wl-handle') ||
            btn.getAttribute('data-handle') ||
            btn.getAttribute('data-product-handle');
    if (h) return h;
    var card = closestCard(btn);
    if (card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (link) return handleFromHref(link.getAttribute('href'));
    }
    return '';
  }

  function resolveTitle(btn) {
    var card = closestCard(btn);
    if (card) {
      var t = card.querySelector('.sw-card__title, .ps__title, .ps__name, h2, h3');
      if (t && t.textContent) return t.textContent.trim().slice(0, 160);
    }
    return '';
  }

  function upgradeLegacy(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(LEGACY);
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      if (btn.hasAttribute('data-dvy-wishlist-toggle')) continue;
      var handle = resolveHandle(btn);
      if (!handle) continue; // handle nahi mila to chhod do, todo mat
      btn.setAttribute('data-dvy-wishlist-toggle', '');
      btn.setAttribute('data-wl-handle', handle);
      var id = btn.getAttribute('data-id') ||
               btn.getAttribute('data-product-id') ||
               (closestCard(btn) && closestCard(btn).getAttribute('data-product-id')) || '';
      if (id) btn.setAttribute('data-wl-id', id);
      var title = resolveTitle(btn);
      if (title) btn.setAttribute('data-wl-title', title);
    }
  }

  /* ============ DOM sync ============ */

  function syncButtons(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var map = Object.create(null);
    read().forEach(function (i) { map[i.handle] = 1; });

    var list = scope.querySelectorAll(ANY);
    for (var i = 0; i < list.length; i++) {
      var btn = list[i];
      var handle = btn.getAttribute('data-wl-handle');
      if (!handle) continue;
      var on = !!map[handle];
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      var txt = btn.querySelector('[data-wl-text]');
      if (txt) txt.textContent = on ? 'Saved' : 'Wishlist';
    }
  }

  function syncCounts() {
    var n = read().length;
    var els = document.querySelectorAll('[data-dvy-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = n > 99 ? '99+' : String(n);
      if (n > 0) els[i].removeAttribute('hidden');
      else els[i].setAttribute('hidden', '');
    }
  }

  function syncAll(root) {
    try { upgradeLegacy(root); syncButtons(root); syncCounts(); } catch (e) {}
  }

  /* ============ unified click (CAPTURE phase) ============
     Capture bubble se pehle chalta hai, isliye legacy delegated
     handlers aur button ke apne listeners dono block ho jaate hain. */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest(ANY) : null;
    if (!btn) return;

    if (!btn.hasAttribute('data-wl-handle')) upgradeLegacy(closestCard(btn) || document);
    var handle = btn.getAttribute('data-wl-handle');
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    API.toggle({
      handle: handle,
      id: btn.getAttribute('data-wl-id'),
      title: btn.getAttribute('data-wl-title')
    });

    btn.classList.remove('dvy-wl-pop');
    void btn.offsetWidth;
    btn.classList.add('dvy-wl-pop');
  }, true);

  /* ============ wiring ============ */

  document.addEventListener(EVT, function () { syncAll(); });

  window.addEventListener('storage', function (e) {
    if (e.key === KEY) emit(read());
  });

  document.addEventListener('shopify:section:load', function (e) { syncAll(e.target); });
  document.addEventListener('dvy:dom:updated', function (e) {
    syncAll(e.detail && e.detail.root);
  });

  /* Fabric section-hydration poora header/section DOM replace karta hai
     bina shopify:section:load fire kiye — isliye observer chahiye. */
  (function observeHydration() {
    if (typeof MutationObserver === 'undefined') return;
    var timer = null;
    var obs = new MutationObserver(function (records) {
      var hit = false;
      for (var i = 0; i < records.length && !hit; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches('[data-dvy-wishlist-count],' + ANY) ||
              n.querySelector('[data-dvy-wishlist-count],' + ANY)) { hit = true; break; }
        }
      }
      if (!hit) return;
      clearTimeout(timer);
      timer = setTimeout(function () { syncAll(); }, 40);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { syncAll(); });
  } else {
    syncAll();
  }

  API.sync = syncAll;
  API.upgrade = upgradeLegacy;
  window.DvyWishlist = API;
})();